import axios from 'axios';
import qs from 'qs';

let baseUrl = '';

class Api {
    constructor (version) {
        let headers = {};

        if (document.body.dataset['apiBaseUrl']) {
            baseUrl = document.body.dataset['apiBaseUrl'].replace(/\/$/, '');
        }

        const appRoot = document.querySelector('#app-root');
        if (appRoot) {
            const jaegerContext = appRoot.dataset['jaegerContext'];
            if (jaegerContext) {
                headers['Uber-Trace-Id'] = jaegerContext;
            }
        }

        this.client = axios.create({
            baseURL: `${baseUrl}/api/v${version}/`,
            headers: headers,
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
        });

        let runningRequestCounter = 0;
        if (appRoot) {
            this.client.interceptors.request.use(config => {
                // for some reason, we need to fetch the app root again here…
                const currentAppRoot = document.querySelector('#app-root');

                runningRequestCounter += 1;
                currentAppRoot.dataset.openRequests = runningRequestCounter;

                return config;
            });

            this.client.interceptors.response.use(response => {
                const currentAppRoot = document.querySelector('#app-root');

                runningRequestCounter -= 1;
                currentAppRoot.dataset.openRequests = runningRequestCounter;

                return response;
                // eslint-disable-next-line handle-callback-err
            }, (error) => {
                const appRoot = document.querySelector('#app-root');

                runningRequestCounter -= 1;
                appRoot.dataset.openRequests = runningRequestCounter;

                // need to return a rejected promise here
                return Promise.reject(error);
            });
        }

        this.client.interceptors.request.use(config => {
            if (!(config.data instanceof FormData)) {
                config.data = qs.stringify(config.data, {
                    encoder: (str, defaultEncoder, charset) => {
                        // Prevent sending string "true"/"false"
                        if (str === true) {
                            return 1;
                        } else if (str === false) {
                            return 0;
                        }

                        return defaultEncoder(str, defaultEncoder, charset);
                    },
                });
            }

            return config;
        });
        this.client.interceptors.response.use(response => {
            // The 1st "data" is Axios, the 2nd our API
            return response.data.data;
        });

        this.errorCallbacks = [];
        this.errorHandlers = [];
        this.client.interceptors.response.use(
            null,
            error => {
                if (error.response) {
                    if (error.response.config.disableErrorCallbacks === true) {
                        return Promise.reject(error);
                    }
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    this.errorCallbacks.map(callback => callback(error));

                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js

                    // We do not return any special error message for canceled requests
                    // return Promise.reject(error);
                }
            }
        );
    }

    async get (url, config) {
        return this.client.get(url, config);
    }

    async put (url, data, config) {
        return this.client.put(url, data, config);
    }

    async post (url, data, config) {
        return this.client.post(url, data, config);
    }

    async delete (url, config) {
        return this.client.delete(url, config);
    }

    onError (callback) {
        this.errorCallbacks.push(callback);
    }

    addErrorHandler (errorHandler) {
        this.errorHandlers.push(errorHandler);
    }

    /**
     * Only to be used in tests.
     *
     * @param newBaseUrl A test installation base URL, like /_ft-abc1234/
     */
    static resetToNewBaseUrl (newBaseUrl) {
        this.apis = [];
        baseUrl = newBaseUrl;
    }

    static version (version) {
        if (!(version in this.apis)) {
            this.apis[version] = new Api(version);
        }

        return this.apis[version];
    }
}
Api.apis = {};

export default Api;
